/**
 * Selected-value chips for RmaListFilterControl: removable labels under the filter header.
 */
import React from "react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";

export interface IRmaListFilterControlChip {
    id: string;
    label: string;
}

interface IProps {
    chips: IRmaListFilterControlChip[];
    disabled?: boolean;
    onClearChip: (event: React.MouseEvent, chipId: string) => void;
}

const RmaListFilterControlChips: React.FC<IProps> = ({ chips, disabled, onClearChip }) => {
    if (chips.length === 0) {
        return null;
    }

    return (
        <div className="rma-list-filter-control__chips">
            {chips.map((chip) => (
                <span key={chip.id} className="rma-list-filter-control__chip">
                    <FontBody2>{chip.label}</FontBody2>
                    <button
                        type="button"
                        className="rma-list-filter-control__chip-clear"
                        onClick={(event) => onClearChip(event, chip.id)}
                        disabled={disabled}
                        aria-label={`Clear ${chip.label}`}
                    >
                        ×
                    </button>
                </span>
            ))}
        </div>
    );
};

export default RmaListFilterControlChips;
